export default function mapTranslations(translations) {
    return {
        currentLanguage: translations.i18n.language,
        changeLanguage: translations.i18n.changeLanguage,
        t: translations.t,
    }
}
